import { render, staticRenderFns } from "./EmailModifyPassword.vue?vue&type=template&id=031bfd2f&scoped=true"
import script from "./EmailModifyPassword.vue?vue&type=script&lang=js"
export * from "./EmailModifyPassword.vue?vue&type=script&lang=js"
import style0 from "./EmailModifyPassword.vue?vue&type=style&index=0&id=031bfd2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031bfd2f",
  null
  
)

export default component.exports